import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "starrating",
  "use": "starrating-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"starrating\"><g fill=\"none\" stroke=\"currentColor\" class=\"nc-icon-wrapper\"><polygon points=\"32 6.833 38 26 58 26 42.108 37.941 48.354 57.167 32 45.285 15.646 57.167 21.892 37.941 6 26 26 26 32 6.833\" stroke-linecap=\"round\" stroke-width=\"2\" stroke-linejoin=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol